import { IlustracaoFolha } from "../illustration/ilustracao-folha";
import { containerMessage } from "./status-message.css";
// import { IlustracaoFolha } from "./illustration/ilustracao-folha.js";

export function StatusMessage({ children }) {
  return (
    <div className={containerMessage} data-testid="containerMessage">
      <IlustracaoFolha />
      {children}
    </div>
  );
}
